(function () {
  function initGeolocation(lib) {
    if (lib && typeof lib.getLocation === "function") {
      lib.getLocation(false, function (locationData) {
        if (locationData && locationData.code) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "userCountryLoaded",
            userCountry: locationData.code
          });
        }
      });
    }
  }

  if (window.PandectesGeolocation) {
    initGeolocation(window.PandectesGeolocation);

    return;
  }

  Object.defineProperty(window, "PandectesGeolocation", {
    configurable: true,
    set: function (val) {
      delete window.PandectesGeolocation;
      window.PandectesGeolocation = val;
      initGeolocation(val);
    }
  });
})();
